import React from "react";
import {Box, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CircleCheckIcon} from "@hugeicons/core-free-icons";
import {a} from "./authStyles";

// Single source of truth for the password policy — the checklist and the form validation both read it.
export const PASSWORD_RULES = [
  {id: "length", label: "10+ characters", test: p => p.length >= 10},
  {id: "lower", label: "Lowercase letter", test: p => /[a-z]/.test(p)},
  {id: "upper", label: "Uppercase letter", test: p => /[A-Z]/.test(p)},
  {id: "number", label: "A number", test: p => /[0-9]/.test(p)},
  {id: "special", label: "Special character", test: p => /[!@#$%^&*(),.?":{}|<>]/.test(p)},
];

export const isPasswordValid = (password) => PASSWORD_RULES.every(rule => rule.test(password));

// Live requirements list: each rule lights up as it is met. After a failed submit, unmet rules turn red.
export const PasswordChecklist = ({password, showErrors}) => (
  <Box sx={{
    display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 12px",
    px: 2, py: 1.75, borderRadius: "14px", bgcolor: "rgba(129,140,248,0.07)",
  }}>
    {PASSWORD_RULES.map(rule => {
      const met = rule.test(password);
      const failed = showErrors && !met;
      return (
        <Box key={rule.id} sx={{display: "flex", alignItems: "center", gap: 0.9}}>
          {met
            ? <HugeiconsIcon icon={CircleCheckIcon} size={15} color={a.accentText}/>
            : <Box sx={{
                width: 15, height: 15, flexShrink: 0, borderRadius: "50%",
                bgcolor: failed ? "rgba(239,68,68,0.25)" : "rgba(20,21,26,0.12)",
                transition: "background-color .2s ease",
              }}/>}
          <Typography sx={{
            fontSize: 13, lineHeight: 1.3, transition: "color .2s ease",
            color: met ? a.ink : failed ? "#DC2626" : a.text,
          }}>
            {rule.label}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
